import { CSSProperties, FC, ReactNode } from "react";
import { BoxContainer, Container } from "./styles";

interface IPlanContainer {
  children?: ReactNode;
  boxWrapper?: boolean;
  width?: string;
  heigth?: string;
  minMax?: boolean;
  style?: CSSProperties;
}

const PlanContainer: FC<IPlanContainer> = ({
  children,
  boxWrapper,
  style,
  heigth,
  minMax,
  width,
}) => {
  return (
    <Container isboxwrapper={boxWrapper}>
      <BoxContainer
        height={heigth}
        width={width}
        minMax={minMax}
        style={{ ...style }}
      >
        {children}
      </BoxContainer>
    </Container>
  )
}

export default PlanContainer;